/** Amplify app hosting portal branch previews. Branch subdomains are matched too. */
const PREVIEW_HOST = "dmpxqf44vgdbz.amplifyapp.com";

const isHostOrSubdomainOf = (hostname: string, host: string) =>
  hostname === host || hostname.endsWith(`.${host}`);

/**
 * devEnvironment - This is a flag to determine if the app is running in a development environment.
 *
 * Matches on `hostname` only. Prod and test share one CloudFront distribution and
 * are told apart solely by their host (`portal.tryrubicon.com` vs
 * `test.portal.tryrubicon.com`), so reading the full href let any prod URL with
 * "test" in its path or query — an org slug, a search term — read as test and
 * resolve every org's `testID` instead of its `id`.
 *
 * @returns {boolean} - Returns true if the app is running in a development environment.
 */
export const devEnvironment = () => {
  const { hostname } = window.location;
  const isLocalhost =
    isHostOrSubdomainOf(hostname, "localhost") ||
    hostname === "127.0.0.1" ||
    hostname === "[::1]";
  const isTest = hostname === "test" || hostname.startsWith("test.");
  const isPreview = isHostOrSubdomainOf(hostname, PREVIEW_HOST);
  return isLocalhost || isTest || isPreview;
};
